import React from 'react';
import Button from '@material-ui/core/Button';
import NotificationService, {
    NotificationTypes
} from '../../../services/NotificationService';
import CompanyService from '../../../services/CompanyService';

function MemberProfilesExport(props) {
    const [disabled, setDisabled] = React.useState(false);

    function exportFile() {
        setDisabled(true);
        CompanyService.exportMemberProfiles()
            .then(() => {
                setDisabled(false);
            })
            .catch((error) => {
                NotificationService.fireNotification(NotificationTypes.error, `Error ${error.message}`);
                setDisabled(false);
            });
    }

    return (
        <React.Fragment>
            <Button disabled={disabled} onClick={exportFile}>Export Member Profiles</Button>
        </React.Fragment>
    );
}

export default MemberProfilesExport;
